import colorConfigs from '../config/colorConfigs';

const Jumper = () => {
  return (
    <div style={{
      backgroundColor: colorConfigs.jumper.bg,
      padding: "20px",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      inset: 0,
      zIndex: 100001
    }}
    >
      <span style={{
        fontSize: "3rem"
      }}>
       Velox Charter
      </span>
    </div>
  );
};

export default Jumper;
